module.exports = __webpack_public_path__ + "static/media/lambo-background.70a730d8.jpg";